import React, { Fragment } from 'react';

import type { DepartmentCardProps } from 'src/components/molecules/DepartmentCard/DepartmentCard';
import { DepartmentCarousel } from 'src/components/organisms/DepartmentCarousel/DepartmentCarousel';
import type { InspirationCategoryCarouselProps } from 'src/components/organisms/InspirationCategoryCarousel/InspirationCategoryCarousel';
import { InspirationCategoryCarousel } from 'src/components/organisms/InspirationCategoryCarousel/InspirationCategoryCarousel';
import type { InspirationLayoutProps } from 'src/components/templates/InspirationLayout/InspirationLayout';
import { InspirationLayout } from 'src/components/templates/InspirationLayout/InspirationLayout';
import * as layoutStyles from 'src/components/templates/InspirationLayout/InspirationLayout.styles';
import * as styles from './InspirationHub.styles';

export type InspirationHubCategory = InspirationCategoryCarouselProps & { id: string };

export type InspirationHubProps = Omit<InspirationLayoutProps, 'children'> & {
  categories: InspirationHubCategory[];
  departments: DepartmentCardProps[];
};

const EMPTY_MESSAGE = 'There are no posts to show right now. Please try again later.';
const DEPARTMENTS_HEADING = 'Shop departments';

export const InspirationHub = ({
  categories,
  departments,
  ...layoutProps
}: InspirationHubProps) => (
  <InspirationLayout {...layoutProps}>
    <div css={layoutStyles.stack}>
      {categories.length === 0 ? (
        <p css={styles.empty}>{EMPTY_MESSAGE}</p>
      ) : (
        categories.map(({ id, ...category }, index) => (
          <Fragment key={id}>
            {index > 0 && <hr css={layoutStyles.divider} />}
            <InspirationCategoryCarousel {...category} />
          </Fragment>
        ))
      )}
      {departments.length > 0 && (
        <>
          <hr css={layoutStyles.divider} />
          <DepartmentCarousel departments={departments} heading={DEPARTMENTS_HEADING} />
        </>
      )}
    </div>
  </InspirationLayout>
);
